// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/common/extensions/v1/custom_options.proto (package quanterix.common.extensions.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { TargetEntity } from "./target_entity_pb";
import { file_quanterix_common_extensions_v1_target_entity } from "./target_entity_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/common/extensions/v1/custom_options.proto.
 */
export const file_quanterix_common_extensions_v1_custom_options: GenFile = /*@__PURE__*/
  fileDesc("CjNxdWFudGVyaXgvY29tbW9uL2V4dGVuc2lvbnMvdjEvY3VzdG9tX29wdGlvbnMucHJvdG8SHnF1YW50ZXJpeC5jb21tb24uZXh0ZW5zaW9ucy52MSLpAQoNQ3VzdG9tT3B0aW9ucxJBCgttYXBwYWJsZV90bxgBIAMoCzIsLnF1YW50ZXJpeC5jb21tb24uZXh0ZW5zaW9ucy52MS5UYXJnZXRFbnRpdHkSDwoHYWxpYXNlcxgCIAMoCRIaCg1pbmhlcml0X3ZhbHVlGAMgASgISACIAQESGgoNY2FzY2FkZV92YWx1ZRgEIAEoCEgBiAEBEhgKC2ltcGxpY2l0X2lkGAUgASgISAKIAQFCEAoOX2luaGVyaXRfdmFsdWVCEAoOX2Nhc2NhZGVfdmFsdWVCDgoMX2ltcGxpY2l0X2lkYgZwcm90bzM", [file_quanterix_common_extensions_v1_target_entity]);

/**
 * Custom options for configuring protobuf transforms
 *
 * @generated from message quanterix.common.extensions.v1.CustomOptions
 */
export type CustomOptions = Message<"quanterix.common.extensions.v1.CustomOptions"> & {
  /**
   * Represents a collection of protobuf entities that this entity is mappable
   * (transformable) to
   *
   * @generated from field: repeated quanterix.common.extensions.v1.TargetEntity mappable_to = 1;
   */
  mappableTo: TargetEntity[];

  /**
   * Represents a set of aliases that this target may also
   * be referred to by (for compatibility purposes)
   *
   * @generated from field: repeated string aliases = 2;
   */
  aliases: string[];

  /**
   * If true, indicates that the value of this target should be
   * inherited from it's parent or nearest ancestor (if present).
   *
   * @remarks This option is applicable to nested messages only
   *
   * @generated from field: optional bool inherit_value = 3;
   */
  inheritValue?: boolean;

  /**
   * If true, indicates that the value of this target may be inherited
   * by descendants (nested messages) of this message
   *
   * @generated from field: optional bool cascade_value = 4;
   */
  cascadeValue?: boolean;

  /**
   * If true, indicates that the value of this field represents an implicit,
   * locally unique identifier (e.g. an entity name), which may be useful
   * as a fallback value or when parsing and comparing messages
   *
   * @generated from field: optional bool implicit_id = 5;
   */
  implicitId?: boolean;
};

/**
 * Describes the message quanterix.common.extensions.v1.CustomOptions.
 * Use `create(CustomOptionsSchema)` to create a new message.
 */
export const CustomOptionsSchema: GenMessage<CustomOptions> = /*@__PURE__*/
  messageDesc(file_quanterix_common_extensions_v1_custom_options, 0);

